import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useOrderChartStore } from "~/stores/use-order-chart-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import OrderChartForm from "./order-chart-form";

export default function OrderChartDialog() {
  const { t } = useTranslation("common");
  const { checkUnsavedChanges } = useUnsavedChanges();

  const {
    setOrderChartFormOpen,
    setSelectedOrderChart,
    orderChartFormOpen,
    selectedOrderChart,
  } = useOrderChartStore();

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) return;
      }
      setSelectedOrderChart(undefined);
    }
    setOrderChartFormOpen(open);
  };
  return (
    <Dialog open={orderChartFormOpen} onOpenChange={handleDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("OrderChart.order_chart")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <OrderChartForm
            orderChart={selectedOrderChart}
            onClose={(force) => handleDialog(false, force)}
          />
        </div>
        <DialogFooter>
          <Button
            form="order-chart-form"
            className="w-full"
            type="submit"
            variant="success"
          >
            {selectedOrderChart?.id
              ? t("OrderChart.update")
              : t("OrderChart.create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
